import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalsRoutingModule } from './approvals-routing.module';
import { ApprovalsContainerComponent } from './components/approvals-container/approvals-container.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ApprovalsContainerComponent],
  imports: [
    CommonModule,
    ApprovalsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ApprovalsModule {}
